import { IPText } from 'baseComponents';
import { IPStack } from 'baseComponents/Stack/IPStack';

import { useTranslation } from 'react-i18next';

const KanbanCardEmptyLane = () => {
  const { t } = useTranslation(['translation']);

  return (
    <div
      style={{
        userSelect: 'none',
        margin: '5px',
        minHeight: '100px',
        borderRadius: '3px',
        border: '1px dashed lightgrey',
      }}
    >
      <IPStack horizontalAlign="center">
        <IPText variant="small" styles={{ root: { paddingTop: 40, color: 'grey' } }}>
          {t('translation:General.Notifications.DropEmptyLane')}
        </IPText>
      </IPStack>
    </div>
  );
};

export default KanbanCardEmptyLane;
